$ ->
  itemSelector = '[data-lesson],[data-post]'

  $('#search-page [data-total]').each ->
    if $(this).data('total') <= 24
      $(this).find('[data-load-more]').hide()

  $('[data-more-button]').click (e) ->
    e.preventDefault()
    $loadBtn = $(this)
    if $loadBtn.is(":disabled")
      return

    $section = $loadBtn.closest('[data-total]')
    nextPage = parseInt($section.data('page')) + 1
    filter = $loadBtn.data('filter')

    searchUrl = 'search?utf8=✓' +
                '&page=' + nextPage +
                '&qs=' + $('#search-param').text() +
                "&filter=" + filter

    $.ajax {
      type: 'get'
      dataType: 'script'
      url: searchUrl
    }

    if $section.data('total') <= (nextPage * 24)
      $section.find('[data-load-more]').hide()

  openAndClose = ($item, $command) ->
    if $command == "open"
      $item.toggle "height" unless $item.is(":visible")
    else if $command == "close"
      $item.toggle "height" if $item.is(":visible")

  $("#filter li").each ->
    $(this).click (e) ->
      if $(this).is(".current, .nonefound")
        e.preventDefault()
      else
        $("#filter .current").toggleClass "current"
        $(this).toggleClass "current"
        filterId = $(this).data('filter')
        if filterId == "all"
          $('div.section > div.title').show()
          openAndClose($('#ted-ed-lessons'), "open")
          openAndClose($('#teded-best-web'), "open")
          openAndClose($('#blog-posts'), "open")
        else
          $item = $('#search-page #' + filterId)
          openAndClose($item, "open")
          $('div.section > div.title').hide()
          if filterId == "ted-ed-lessons"
            openAndClose($('#teded-best-web'), "close")
            openAndClose($('#blog-posts'), "close")
          else if filterId == "teded-best-web"
            openAndClose($('#ted-ed-lessons'), "close")
            openAndClose($('#blog-posts'), "close")
          else
            openAndClose($('#ted-ed-lessons'), "close")
            openAndClose($('#teded-best-web'), "close")

  hash = window.location.hash
  if hash is "#tededlessons"
    $("[data-filter=\"ted-ed-lessons\"]").trigger "click"
  else if hash is "#bestofweb"
    $("[data-filter=\"teded-best-web\"]").trigger "click"
  else if hash is "#blogposts"
    $("[data-filter=\"blog-posts\"]").trigger "click"
